import { ScreenerFilter } from '@api/api/screener';
import { TFunction } from 'i18next';

export const createDatePickerFilter = (t: TFunction): ScreenerFilter => {
  return {
    key: 'date-picker',
    name: t('news:filters.dateRange'),
    visible: true,
    searchable: false,
    category: '',
    locked: true,
    dynamic: false,
    config: {
      multiselect: false,
      name: t('news:filters.dateRange'),
      options: [
        {
          name: t('news:filters.dateRangeOptions.today'),
          key: 'today',
          value: {
            from: '',
            to: '',
          },
        },
        {
          name: t('news:filters.dateRangeOptions.yesterday'),
          key: 'yesterday',
          value: {
            from: '',
            to: '',
          },
        },
      ],
      custom: {
        key: 'date-range',
        name: t('news:filters.dateRangeOptions.datepicker'),
        custom: [],
      },
    },
  };
};
